import { Damage, GetDamageMatrixResponse } from "@inbound/api";

const getDamageScore = (
  damageMatrix: GetDamageMatrixResponse[],
  damage: Damage,
) =>
  damageMatrix.find(
    (matrix) =>
      damage.id === matrix.damage?.id && // back
      damage.locationId === matrix.damageLocation?.id && // back
      // damage.parentId === matrix.parentDamage?.id &&
      damage.severity === matrix.severity?.id,
  )?.score ?? 0;

export default getDamageScore;
